import PracticeLibraryResultsAsync from './PracticeLibraryResultsAsync';

export default PracticeLibraryResultsAsync;
